import { Button, Card, Stack, cn, buttonVariants } from 'design-system'
import { Link } from 'src/lib/router'

export const TimeoutError = () => {
  return (
    <Card className="w-full max-w-120 rounded-lg border-t-8 border-red-600 p-6 pt-4">
      <Stack gap={3}>
        <h2 className="text-center text-lg">Oops! That took too long.</h2>
        <p className="text-sm text-slate-500">
          Your request could not be completed, please try again later!
        </p>
        <p className="text-sm text-slate-500">
          If the problem continues, please contact us at{' '}
          <a href="mailto:support@yellowdig.com">support@yellowdig.com</a>
        </p>
        <div className="flex justify-center gap-2">
          <Button
            buttonType="secondary"
            className="w-44 border border-blue-600"
            buttonSize="sm"
            onClick={() => {
              window.location.reload()
            }}>
            Retry
          </Button>
          <Link
            className={cn(
              buttonVariants({ buttonType: 'primary', buttonSize: 'sm' }),
              'w-44 font-normal'
            )}
            href="/home">
            Go Home
          </Link>
        </div>
      </Stack>
    </Card>
  )
}
